// The admin-website pages a staff role can grant (the backend's StaffFeatureEnum). The Dashboard is just
// links to these pages, so every signed-in staff member has it and it needs no feature.
export interface IStaffFeature {
  key: string;
  // i18n key of the page's name (the sidebar label)
  navKey: string;
}

export const STAFF_FEATURES: IStaffFeature[] = [
  { key: 'FUNNEL', navKey: 'nav.funnel' },
  { key: 'PERMISSIONS', navKey: 'nav.permissions' },
  { key: 'PROTECT_MODE', navKey: 'nav.protectMode' },
  { key: 'CALLS', navKey: 'nav.calls' },
  { key: 'LOCATION', navKey: 'nav.location' },
  { key: 'SAFETY_ALERTS', navKey: 'nav.safetyAlerts' },
  { key: 'ERROR_LOGS', navKey: 'nav.errorLogs' },
  { key: 'SUPPORT_REQUESTS', navKey: 'nav.supportRequests' },
];
